<template>
  <div>
    <div class="myheader" v-if="isLogin">
      <p style="display: flex;align-items: center;margin-bottom: 0.25rem">{{ userinfo.accountName }}
        <md-button type="warning" v-if="userinfo.userGradeInfo" size="small" inline style="background-color: #fedd59;color: #333333;height: 0.5rem;width: 1.2rem;font-size: 0.2rem;margin-left: 0.2rem">LV.{{userinfo.userGradeInfo.name}}</md-button>
      </p>
      <span @click="copy(userinfo.accountCode)"
        >會員號：{{ userinfo.accountCode }}
        <img src="@/assets/image/copy.png" alt=""
      /></span>
      <div class="userinfo">
        <p @click="goNext(0)">{{ account }}<span>余额</span></p>
        <p @click="whjqjkjker">{{ credit }}<span>积分</span></p>
        <p @click="goNext(3)">{{ couop }}<span>优惠券</span></p>
      </div>
    </div>
    <div class="myheader" v-else>
      <div class="userinfod">
        <div class="userimg" @click="login">
          <img
            src="@/assets/image/banner.jpg"
            alt=""
            style="width: 1rem; height: auto; border-radius: 0.2rem"
            v-if="!shopkey.appCode"
          />
          <span>登入/注册</span>
        </div>
      </div>
    </div>
    <div style="width: 100%; height: 4rem"></div>
    <md-dialog
      title="邀请地址"
      :closable="false"
      v-model="warnDialog.open"
      :btns="warnDialog.btns"
    >
    <div class="copurl">
      <span> {{url}}</span>
     </div>
    </md-dialog>
    <md-field>
      <md-cell-item
        title="用户等级"
        arrow
        @click="gogren()"
        v-if="userinfo.userGradeInfo"
      >
        <div slot="right" v-if="userinfo.userGradeInfo.discount!=10">
          <span style="margin-right: 5px"> {{userinfo.userGradeInfo.name}}</span>

          <md-tag size="large"  shape="fillet"
                  type="ghost"
                  fill-color="rgba(255, 91, 96, .1)"
                  font-weight="normal"
                  font-color="#FF5B60">享运费{{userinfo.userGradeInfo.discount}}折</md-tag>
        </div>
        <div slot="right" v-else>
          <span style="margin-right: 5px"> {{userinfo.userGradeInfo.name}}</span>

          <md-tag size="large"  shape="fillet"
                  type="ghost"
                  fill-color="rgba(255, 91, 96, .1)"
                  font-weight="normal"
                  font-color="#FF5B60">无折扣</md-tag>
        </div>
        <img src="@/assets/image/huang.png" alt="" slot="left" />
      </md-cell-item>
      <md-cell-item
        v-for="(item, index) in alllist"
        :key="index"
        :title="item.name"
        arrow
        @click="goNext(index)"
        :no-border="index == alllist.length ? true : false"
      >
        <img :src="item.img" alt="" slot="left" />
      </md-cell-item>
    </md-field>
    <div class="kkker" @click="whjqjkjker">
      <span>任务中心</span>
    </div>
    <div style="height:3rem"></div>
  </div>
</template>

<script>
import { Dialog, Field, CellItem, Icon, Toast,Tag ,Button} from "mand-mobile";
//1
export default {
  name: "My",
  components: {
    [Dialog.name]: Dialog,
    [Field.name]: Field,
    [CellItem.name]: CellItem,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Button.name]: Button,
  },
  data() {
    return {
      credit: 0,
      couop: 0,
      account: 0,
      isLine:false,
      url:'',
       warnDialog: {
        open: false,
        btns: [
          {
            text: '取消',
          },
          {
            text: '复制',
            handler: this.xinr,
          },
        ],
      },
      isLogin: false,
      alllist:[],
      list: [
        { name: "账户余额", img: require("@/assets/image/icon_balance.png") },
        { name: "帳號資訊", img: require("@/assets/image/icon_record.png") },
        {
          name: "交易記錄",
          img: require("@/assets/image/icon_trade.png")
        },
        { name: "優惠券", img: require("@/assets/image/icon_coupon.png") },
        {
          name: "海外地址管理",
          img: require("@/assets/image/icon_address.png")
        },
        { name: "綁定淘寶賬號", img: require("@/assets/image/user.png") },
        { name: "邀请好友", img: 'https://app.huyuntong.com/app/static/images/mini/icon_record.png' },
         { name: "用户反馈", img: 'https://app.huyuntong.com/app/static/images/mini/icon_feed_back.png' },
        { name: "Line通知", img: 'https://app.huyuntong.com/images/消息提醒_09-100faeab-ba35-4dac-a014-32bab90e956a.png' },
        { name: "退出登錄", img: require("@/assets/image/tui.png") },

      ],
      userinfo: {},
      shopkey: {}
    };
  },
  beforeRouteLeave(to, from, next) {
    if (
      localStorage.getItem("mupressMobiltoken") &&
      localStorage.getItem("userinfoMobie")
    ) {
      next();
    } else {
      if (to.name == "Package" || to.name == "Order") {
        var index = 7;
        to.name == "Package" ? (index = 7) : (index = 8);
        this.$router.push({
          name: "Login",
          query: {
            id: "0",
            index: index,
            pagename: localStorage.getItem("fircontename")
          }
        });
      } else {
        next();
      }
    }
  },
  mounted() {
    this.isBindShopDate();
    if (localStorage.getItem("mupressMobiltoken")) {
      Toast.loading("请稍等...");
      this.getcreduit();
    } else {
      this.isLogin = false;
    }
  },
  methods: {
    isBindShopDate() {
      if (localStorage.getItem("shopkey")) {
        this.shopkey = JSON.parse(localStorage.getItem("shopkey"));
      }
    },
    getUserInfo(){
      this.http.APIASK(this.ports.getUserInfo, "get").then(res => {
        localStorage.setItem('userinfoMobie',JSON.stringify(res))
        this.userinfo = JSON.parse(localStorage.getItem("userinfoMobie"));
        this.isLogin = true;
        Toast.hide();
      });
    },
    getcreduit() {
      this.http.APIASK(this.ports.getUserCredituer, "get").then(res => {
        this.credit = res.credit;
        this.getAccount()
      }).catch(err=>{
        Toast.hide();
      });


      this.getUserInfo();
    },
    getAccount(){
      this.ajax.AJAx(this.ports.getUserAccount, "post").then(res => {
        const { money } = res;
        this.account = (money / 100).toFixed(2);
        this.getcoup()
        this.getisLineNotify()
      });
    },
    getcoup(){
      this.http.APIASK(this.ports.couponsallCount, "get").then(res => {
        this.couop = res;
      });
    },
    gogren(){
      this.$router.push({
        name: "Grandlisy",
      });
    },
    login() {
      this.$router.push({
        name: "Login",
        query: {
          id: localStorage.getItem("firconteid"),
          index: 9,
          pagename: "MY"
        }
      });
    },
    whjqjkjker() {
      if (localStorage.getItem("mupressMobiltoken")) {
        this.$router.push({
          name: "Userjifen",
          query: {
            cnm: localStorage.getItem("mupressMobiltoken")
          }
        });
      } else {
        this.$router.push({
          name: "Login",
          query: {
            id: localStorage.getItem("firconteid"),
            index: parseInt(3),
            pagename: localStorage.getItem("fircontename")
          }
        });
      }
    },
    xinr(){
       this.copy(this.url)
       this.warnDialog.open=false
    },
    copy(name) {
      const url = name;
      const oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("Copy"); // 执行浏览器复制命令
      oInput.remove();
      Toast.succeed("複製成功");
    },
    logout() {
      this.http.APIASK(this.ports.loginOut, "post").then(res => {
        localStorage.removeItem("userinfoMobie");
        localStorage.removeItem("mupressMobiltoken");
        localStorage.removeItem("headerParams");
        this.$router.replace({
          name: "Login"
        });
      });
    },
    feadback(){
       this.$router.push({
              name: "Feadback",
            });
    },
    getline(){
      if(this.isLine){
        this.http.APIASK(this.ports.getLineNotifyOauthUrl, "get").then(res => {
          console.log(res+'_'+localStorage.getItem('mupressMobiltoken')+'_'+ JSON.parse(localStorage.getItem('shopkey')).appCode)
          window.location.href=res+'_'+localStorage.getItem('mupressMobiltoken')+'_'+ JSON.parse(localStorage.getItem('shopkey')).appCode
        });
      }else{
        Dialog.confirm({
          title: "確認",
          content: "請確認是否退出賬號",
          confirmText: "確定",
          onConfirm: () => {
            this.logout();
          }
        });
      }

    },
    getisLineNotify(){
      this.http.APIASK(this.ports.isLineNotify, "post").then(res => {
       this.isLine=true
        if(!this.isLine){
          let alllist=[]
          let list=JSON.parse(JSON.stringify(this.list))
          // Line通知
          list.map(val=>{
            if(val.name!='Line通知'){
              alllist.push(val)
            }
          })
          this.alllist=alllist
          // this.list
        }else{
          this.alllist=JSON.parse(JSON.stringify(this.list))
        }
      });

    },
    invater(){
      if(window.location.host === 'huyuntong.com') {
        this.url=`${window.location.host}/res/m/#/login?parentCode=${JSON.parse(localStorage.getItem('userinfoMobie')).accountCode}`
      }else {
        this.url=`${window.location.host}/#/login?parentCode=${JSON.parse(localStorage.getItem('userinfoMobie')).accountCode}`
      }
      this.warnDialog.open = true
    },
    goNext(index) {
      console.log(parseInt(index + 10));
      if (localStorage.getItem("mupressMobiltoken")) {
        switch (parseInt(index + 10)) {
          case 10:
            this.$router.push({
              name: "Chongzhi",
              query: {
                id: JSON.parse(localStorage.getItem("userinfoMobie")).disVo.id
              }
            });
            break;
          case 11:
            this.$router.push({
              name: "UseRepert",
              query: {
                id: JSON.parse(localStorage.getItem("userinfoMobie")).disVo.id
              }
            });
            break;
          case 12:
            this.$router.push({
              name: "Transaction",
              query: {
                id: JSON.parse(localStorage.getItem("userinfoMobie")).disVo.id
              }
            });
            break;
          case 13:
            this.$router.push({
              name: "Coup",
              query: {
                id: JSON.parse(localStorage.getItem("userinfoMobie")).disVo.id
              }
            });
            break;
          case 14:
            this.$router.push({
              name: "AddressUser",
              query: {
                id: JSON.parse(localStorage.getItem("userinfoMobie")).disVo.id
              }
            });
            break;
          case 15:
            this.$router.push({
              name: "BindTaoBaoShop",
            });
            break;
          case 16:
            this.invater()
            break;
             case 17:
            this.feadback()
            break;
               break;
          case 18:
            this.getline()
            break;
          case 19:
            Dialog.confirm({
              title: "確認",
              content: "請確認是否退出賬號",
              confirmText: "確定",
              onConfirm: () => {
                this.logout();
              }
            });
            break;
        }
      } else {
        this.$router.push({
          name: "Login",
          query: {
            id: localStorage.getItem("firconteid"),
            index: parseInt(index + 10),
            pagename: localStorage.getItem("fircontename")
          }
        });
      }
    }
  }
};
</script>
<style lang="less">
  .myheader {
    width: 100%;
    height: 2.5rem;
    background-color: #e32c1a;
    position: fixed;
    top: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-size: 0.3rem;
    color: white;
    z-index: 999;
    p {
      margin-left: 0.5rem;
      margin-top: 0.5rem;
    }
    span {
      margin-left: 0.5rem;
    }
    img {
      margin-left: 0.5rem;
      width: 0.5rem;
      margin-bottom: -0.1rem;
    }
    .userinfo {
      position: absolute;
      top: 2.1rem;
      height: 1.5rem;
      width: 94%;
      margin-left: 3%;
      background-color: white;
      border-radius: 0.15rem;
      display: flex;
      justify-content: space-around;
      align-items: center;
      p {
        font-size: 0.4rem;
        color: #f44444;
        margin-left: 0.2rem;
        margin-top: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        span {
          color: #999999;
          margin: 0;
          font-size: 0.3rem;
          margin-top: 0.1rem;
        }
      }
    }
  }

  fieldset {
    padding-top: 0;
    padding-bottom: 0;
  }

  .md-cell-item-title {
    text-align: left;
  }

  .md-cell-item-body {
    padding: 0;
  }
  .md-cell-item-body:before {
    content: "";
    position: absolute;
    z-index: 2;
    -webkit-transform: scaleY(0.5) translateY(100%);
    transform: scaleY(0.5) translateY(100%);
    bottom: 0;
    left: 0;
    right: auto;
    top: auto;
    width: 100%;
    border-bottom: 0.02rem solid #e2e4ea;
    -webkit-transform-origin: 50% 100%;
    transform-origin: 50% 100%;
  }
  .md-cell-item-left {
    display: flex;
    align-items: center;
  }

  img {
    width: 0.5rem;
  }

.kkker {
  position: fixed;
  right: 0;
  top: 0.8rem;
  width: 1.5rem;
  height: 0.6rem;
  background-color: #fedd59;
  color: #ff6200;
  font-size: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top-left-radius: 0.4rem;
  border-bottom-left-radius: 0.4rem;
  z-index: 999;
  span {
    margin-left: 0.5rem;
  }

  .userinfod {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .userimg {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
}
.copurl{
  height: 1rem;
  line-height: 0.5rem;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
}
</style>
